// All site data for Ellis Goward portfolio (mocked)

export const profile = {
  firstName: 'ELLIS',
  lastName: 'GOWARD',
  shortName: 'ELLIS GOWARD',
  taglineKicker: '// Director \u00b7 Creative Director \u00b7 Cinematographer \u00b7 Photographer',
  bioLead:
    'Director at Wedding Video Essex, WVE Studios and the WVE Group. A decade of wedding photography, cinema, live event production and broadcast grade media. 900+ weddings captured on stills and film, seven industry awards, twenty six recommended venues.',
  email: 'ellis@weddingvideo.co.uk',
  phone: '07500 671949',
  phoneHref: 'tel:+447500671949',
  group: 'wvegroup.co.uk',
  groupHref: 'https://www.wvegroup.co.uk/',
  headshot:
    'https://static.wixstatic.com/media/1fe187_451802347d194e08b9aff9bef88309b1~mv2.jpg/v1/crop/x_1196,y_0,w_4037,h_4541/fill/w_516,h_620,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/ELLIS-TEAM-PHOTOS-WVE.jpg',
  fileMeta: {
    name: 'ELLISGOWARD_HEADSHOT.JPG',
    iso: 'ISO 400',
    aperture: 'F/4',
    shutter: '1/200',
  },
};

export const stats = [
  { value: '900+', label: 'Weddings Captured' },
  { value: '07', label: 'Industry Awards' },
  { value: '26', label: 'Recommended Venues' },
  { value: '10+', label: 'Years In Business' },
];

export const showreel = {
  kicker: 'SEQUENCE // 01',
  title: 'The Showreel',
  description:
    'A cut of recent wedding photography, wedding films, live event work and studio productions. Shot, directed and edited under the WVE banner.',
  youtubeId: 'bjuzwS5xkZQ',
  thumb: 'https://img.youtube.com/vi/bjuzwS5xkZQ/maxresdefault.jpg',
};

export const brands = [
  'BBC',
  'DELIVEROO',
  'LINKEDIN',
  'AMAZON',
  'AMERICAN EXPRESS',
  'EE',
  'GOV.UK',
  'MAJESTIC WINES',
  'BAFTA',
  'SHELL',
  'FERRARI',
];

export const group = {
  kicker: 'SEQUENCE // 02',
  title: 'The WVE Group',
  description:
    'Five specialised brands. A complete wedding photography, videography and creative production ecosystem operating from Essex.',
  cards: [
    {
      n: '01',
      tag: 'Photography & Videography Brand',
      name: 'Wedding Video Essex',
      body:
        "The flagship. Essex's most recommended wedding photography and videography brand. 900+ weddings captured, seven industry awards, twenty six venue recommendations.",
      href: 'https://www.weddingvideo.co.uk/',
    },
    {
      n: '02',
      tag: 'Studio, Stills, Live & Production',
      name: 'WVE Studios',
      body:
        'Purpose built Wickford studio for portrait photography, video and audio. Also live streaming, business promos, event production, corporate broadcast and multi camera relay work.',
      href: 'https://www.wvestudios.co.uk/',
    },
    {
      n: '03',
      tag: 'Wedding stills',
      name: 'Chic Photography',
      body: 'Editorial wedding photography across Essex and the South East.',
      href: 'https://www.chicwedding-photography.com/',
    },
    {
      n: '04',
      tag: 'Modern wedding films & photos',
      name: 'Click Play Weddings',
      body: 'A second creative line. Accessible cinematic coverage and stills for modern couples.',
      href: 'https://www.clickplayweddings.co.uk/',
    },
    {
      n: '05',
      tag: 'Creative production',
      name: 'Best Day Ever Productions',
      body: 'Storytelling led photo and film production for couples who want a different kind of wedding archive.',
      href: 'https://bestdayeverproductions.co.uk/',
    },
  ],
};

export const experience = {
  kicker: 'SEQUENCE // 03',
  title: 'Experience',
  description:
    'A career built across every seat in the production chair, from camera and stills to live multi-camera broadcast.',
  items: [
    {
      period: '2015 \u2013 Present',
      location: 'Essex, UK',
      role: 'Creative Director',
      company: 'Wedding Video Essex Ltd \u00b7 The WVE Group',
      bullets: [
        'Built Wedding Video Essex into a market leading wedding photography & videography brand. 900+ weddings captured to date.',
        'Won seven industry awards and secured recommended supplier status at 26 Essex venues.',
        'Scaled the group to five brands and a six strong core team plus a seasonal subcontractor model.',
        'Direct creative output, sales and operations across the group.',
      ],
    },
    {
      period: '2015 \u2013 Present',
      location: 'Wickford, Essex',
      role: 'Director',
      company: 'WVE Studios Ltd',
      bullets: [
        'Built and run a purpose built Wickford photography and production studio.',
        'Deliver wedding stills and films, business promos, artist showreels, dance and theatre shows, corporate content.',
        'Produce and direct live multi camera broadcasts including corporate seminars and relay productions.',
        'Lead end to end production: camera, stills, directing, producing, sound and editing.',
      ],
    },
  ],
};

export const toolkit = {
  kicker: 'SEQUENCE // 04',
  title: 'The Toolkit',
  description:
    'Every seat in the production chair. From shutter click to colour grade and from live mix to broadcast relay.',
  groups: [
    {
      n: '01',
      title: 'Camera & Direction',
      items: [
        'Wedding Photography',
        'Wedding Videography',
        'Portrait Photography',
        'Multi-Camera Production',
        'Cinematography',
        'Directing',
        'Sound Recording',
      ],
    },
    {
      n: '02',
      title: 'Post-Production',
      items: [
        'Adobe Lightroom Classic',
        'Capture One',
        'Final Cut Pro X, Apple Certified',
        'Adobe Premiere Pro',
        'DaVinci Resolve',
        'Colour Grading & Retouching',
      ],
    },
    {
      n: '03',
      title: 'Live & Broadcast',
      items: [
        'Live Event Production',
        'Live Streaming',
        'Broadcast Relay',
        'Multi-Cam Switching',
        'Corporate Seminars',
      ],
    },
    {
      n: '04',
      title: 'Business & Operations',
      items: [
        'Team Leadership',
        'Sales Strategy',
        'Client Relationship Mgmt.',
        'Project Management',
      ],
    },
  ],
};

export const notable = {
  kicker: 'SEQUENCE // 05',
  title: 'Notable Work & Achievements',
  description:
    'Selected highlights from a decade of weddings, photography, live events, corporate productions and short films.',
  items: [
    {
      n: '01',
      tag: 'CLIP',
      title: 'Award winning films and photography',
      body:
        'Filmed and photographed several award winning shorts. Two films screened theatrically at Odeon cinemas.',
    },
    {
      n: '02',
      tag: 'CLIP',
      title: '900+ weddings captured',
      body:
        'Stills and film, across Essex and the South East over a decade of continuous production.',
    },
    {
      n: '03',
      tag: 'CLIP',
      title: 'Seven industry awards',
      body:
        'Hitched Highest Rated, Bridebook Platinum and Essex Wedding Awards Best Videographer & Photographer among others.',
    },
    {
      n: '04',
      tag: 'CLIP',
      title: 'Recommended at 26 Essex venues',
      body:
        "Listed and trusted by Essex's top wedding venues as a preferred photo and video supplier.",
    },
    {
      n: '05',
      tag: 'CLIP',
      title: 'High value corporate live productions',
      body:
        'Broadcast relay seminars and multi camera live streams for major brand clients.',
    },
  ],
};

export const education = {
  kicker: 'SEQUENCE // 06',
  title: 'Education & Certifications',
  items: [
    {
      period: '2012 \u2013 2015',
      school: 'University of Essex',
      degree:
        "Bachelor's Degree, Television Production. 2:1 Upper Second Class Honours",
      detail:
        'Specialised in Television Production with additional study in Film, Animation, Photography and Journalism.',
    },
    {
      period: '2010 \u2013 2012',
      school: 'South Essex College',
      degree: 'BTEC, Film and Television. Triple Distinction* (D*D*D*)',
      detail: 'Produced short films and documentaries.',
    },
  ],
  certs: {
    title: 'Credentials & Recognition',
    items: [
      'Apple Certified Pro, Final Cut Pro X (2014)',
      'Hitched Highest Rated',
      'Bridebook Platinum',
      'Essex Wedding Awards, Best Videographer & Photographer',
      'Wix \u201cLegend\u201d Certification',
    ],
  },
};

export const nav = [
  { label: 'SHOWREEL', href: '#showreel' },
  { label: 'THE GROUP', href: '#group' },
  { label: 'EXPERIENCE', href: '#experience' },
  { label: 'SKILLS', href: '#toolkit' },
  { label: 'CONTACT', href: '#contact' },
];
